import { advancedSearchApi } from '@ardoq/api';
import {
  APIScopeData,
  BooleanOperator,
  hasStartSet,
  Operator,
  QueryBuilderQuery,
  QueryBuilderRow,
  SearchContext,
  TraversalParams,
} from '@ardoq/api-types';
import { isArdoqError } from '@ardoq/common-helpers';
import { logError } from '@ardoq/logging';
import { scopeDataOperations } from '@ardoq/scope-data';

export const getStartSetScopeData = async (
  loadedStateData: TraversalParams,
  scopeData: APIScopeData,
  abortSignal?: AbortSignal
) => {
  const hasSomeLoadedData = scopeData.components.length > 0;
  if (hasSomeLoadedData) {
    return scopeDataOperations.getEmpty();
  }
  if (hasStartSet(loadedStateData.componentSelection)) {
    const startSet = loadedStateData.componentSelection.startSet;
    const startSetComponents = await loadStartSet(startSet, abortSignal);
    if (isArdoqError(startSetComponents)) {
      logError(Error('Failed to load start set as scope data'));
      return scopeDataOperations.getEmpty();
    }
    return startSetComponents;
  }
  return scopeDataOperations.getEmpty();
};

const loadStartSet = async (
  componentIds: string[],
  abortSignal?: AbortSignal
) => {
  const query = getQueryForComponentIds(componentIds);
  const result = await advancedSearchApi.scopeData(
    { query, minimal: true },
    abortSignal
  );
  return result;
};

const getQueryForComponentIds = (componentIds: string[]): QueryBuilderQuery => {
  return {
    condition: BooleanOperator.AND,
    rules: [
      {
        field: 'type',
        id: 'type',
        input: 'select',
        operator: Operator.EQUAL,
        type: 'string',
        value: SearchContext.COMPONENT,
      },
      {
        condition: BooleanOperator.OR,
        rules: componentIds.map(componentIdToQuery),
      },
    ],
  };
};

const componentIdToQuery = (componentId: string): QueryBuilderRow => ({
  id: '_id',
  field: '_id',
  input: 'text',
  type: 'string',
  operator: Operator.EQUAL,
  value: componentId,
});
